'use client'

import { Button } from '@/base_components/ui/button'
import { cn } from '@/lib/utils'
import { format, isToday } from 'date-fns'
import { Matcher } from 'react-day-picker'
import DatePicker from '../DatePicker'

type JumpToDateProps = {
  selectedDate: Date
  onDateChange: (date: Date) => void
  disabled?: Matcher | Matcher[]
  displaySelectedDate?: boolean
  triggerClassName?: string
  footerContent?: (handleSelectDate: (date: Date) => void) => React.ReactNode
  autoApply?: boolean
}

const JumpToDate: React.FC<JumpToDateProps> = ({
  selectedDate,
  onDateChange,
  disabled,
  displaySelectedDate = true,
  triggerClassName,
  footerContent,
  autoApply = false,
}) => {
  const date = isToday(selectedDate) ? undefined : selectedDate

  return (
    <DatePicker
      selectedDate={selectedDate}
      onDateChange={onDateChange}
      disabled={disabled}
      autoApply={autoApply}
      footerContent={footerContent}
      triggerButton={
        <Button
          variant="outline"
          className={cn(
            '~w-auto max-[870px]:~w-full ~h-[65px] ~px-4 ~gap-2 ~justify-start ~text-left ~font-normal ~rounded',
            triggerClassName
          )}
        >
          <img
            src="/icons/calendar-black.svg"
            alt="Calendar"
            className="~flex-shrink-0"
          />

          <span className="~hidden max-[870px]:~block">
            {isToday(selectedDate) ? 'Today, ' : ''}
            {format(selectedDate, 'MMMM d, yyyy')}
          </span>

          <span className="max-[870px]:~hidden">
            {date && displaySelectedDate
              ? format(date, 'MM/dd/yyyy')
              : 'Jump to date'}
          </span>
        </Button>
      }
    />
  )
}

export default JumpToDate
